{
  "shell": {
    "headline": "กล่องข้อความเดียว สำหรับร้านค้าไทย",
    "subheadline": "รวมแชทจาก LINE OA · Facebook · Instagram พร้อม CRM และระบบเรียกเก็บเงินผ่าน PromptPay",
    "stats": {
      "trialValue": "ฟรี 7 วัน",
      "trialLabel": "ไม่ใช้บัตร",
      "promptpayValue": "PromptPay",
      "promptpayLabel": "ชำระสะดวก",
      "uptimeValue": "99%",
      "uptimeLabel": "uptime"
    }
  },
  "login": {
    "title": "ยินดีต้อนรับกลับมา",
    "subtitle": "เข้าสู่ระบบ Sight Order เพื่อจัดการแชทร้านของคุณ",
    "rememberMe": "จดจำฉันไว้ 30 วัน",
    "divider": "หรือ",
    "forgotPassword": "ลืมรหัสผ่าน?",
    "noAccount": "ยังไม่มีบัญชี?",
    "signUpFree": "สมัครฟรี",
    "reasonSessionExpired": "เซสชันหมดอายุ กรุณาเข้าสู่ระบบอีกครั้ง",
    "reasonRefreshFailed": "ไม่สามารถต่ออายุเซสชันได้ กรุณาเข้าสู่ระบบอีกครั้ง",
    "reasonRemoteTab": "คุณออกจากระบบในแท็บอื่น กรุณาเข้าสู่ระบบอีกครั้ง"
  },
  "register": {
    "title": "สร้างบัญชีใหม่",
    "subtitle": "ทดลองใช้ฟรี 7 วัน · ไม่ต้องใช้บัตรเครดิต",
    "divider": "หรือ",
    "termsPrefix": "การสมัครถือว่าคุณยอมรับ",
    "termsLink": "เงื่อนไขการใช้งาน",
    "termsAnd": "และ",
    "privacyLink": "นโยบายความเป็นส่วนตัว",
    "haveAccount": "มีบัญชีแล้ว?",
    "signIn": "เข้าสู่ระบบ"
  },
  "forgot": {
    "title": "ลืมรหัสผ่าน",
    "subtitle": "กรอกอีเมลเพื่อรับลิงก์ตั้งรหัสผ่านใหม่",
    "submit": "ส่งลิงก์รีเซ็ตรหัสผ่าน",
    "backToLogin": "กลับไปหน้าเข้าสู่ระบบ",
    "sentTitle": "ตรวจสอบอีเมลของคุณ",
    "sentSubtitle": "หากมีบัญชีอยู่ เราได้ส่งลิงก์รีเซ็ตรหัสผ่านไปแล้ว",
    "sentBody": "กรุณาเปิดอีเมลและกดลิงก์เพื่อตั้งรหัสผ่านใหม่ ลิงก์อาจใช้เวลาสักครู่จึงจะมาถึง"
  },
  "verify": {
    "title": "ยืนยันอีเมลของคุณ",
    "subtitle": "เราได้ส่งลิงก์ยืนยันไปที่ {{email}}",
    "fallbackEmail": "อีเมลของคุณ",
    "body": "กรุณาเปิดอีเมลและกดลิงก์เพื่อยืนยันบัญชี จากนั้นกลับมาที่หน้านี้แล้วกด “ฉันยืนยันแล้ว”",
    "confirmed": "ฉันยืนยันแล้ว",
    "resend": "ส่งอีเมลยืนยันอีกครั้ง",
    "resendSuccess": "ส่งอีเมลยืนยันอีกครั้งแล้ว",
    "notVerifiedYet": "ยังไม่พบการยืนยัน กรุณากดลิงก์ในอีเมลก่อน",
    "signOut": "ออกจากระบบ"
  },
  "consent": {
    "version": "เวอร์ชัน {{version}}",
    "progress": " — {{current}} จาก {{total}}",
    "viewFullDocument": "ดูเอกสารฉบับเต็ม",
    "scrollToAccept": "เลื่อนอ่านให้จบเพื่อกดยอมรับ",
    "accept": "ยอมรับ",
    "saveFailed": "ไม่สามารถบันทึกได้ กรุณาลองใหม่อีกครั้ง"
  },
  "form": {
    "emailLabel": "อีเมล",
    "emailRequired": "กรุณากรอกอีเมล",
    "emailInvalid": "อีเมลไม่ถูกต้อง",
    "passwordLabel": "รหัสผ่าน",
    "passwordRequired": "กรุณากรอกรหัสผ่าน",
    "passwordTooShort": "รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร",
    "submitRegister": "สมัครด้วยอีเมล",
    "submitLogin": "เข้าสู่ระบบ"
  },
  "google": {
    "button": "เข้าสู่ระบบด้วย Google",
    "loading": "กำลังเข้าสู่ระบบ...",
    "popupBlocked": "เบราว์เซอร์บล็อกป๊อปอัพ กรุณาอนุญาตและลองใหม่",
    "unauthorizedDomain": "โดเมนนี้ยังไม่ได้รับอนุญาตในการเข้าสู่ระบบ Google",
    "notEnabled": "Google sign-in ยังไม่เปิดใช้งานในบัญชีนี้",
    "invalidTenant": "Tenant ID ไม่ถูกต้อง",
    "failedWithCode": "ไม่สามารถเข้าสู่ระบบด้วย Google ได้: {{code}}",
    "failed": "ไม่สามารถเข้าสู่ระบบด้วย Google ได้ กรุณาลองใหม่อีกครั้ง"
  },
  "inApp": {
    "title": "เข้าสู่ระบบด้วย Google ในแอป {{app}} ไม่ได้",
    "titleUnnamed": "เข้าสู่ระบบด้วย Google ในเบราว์เซอร์ของแอปนี้ไม่ได้",
    "body": "เปิดหน้านี้ใน Chrome หรือ Safari เพื่อเข้าสู่ระบบด้วย Google หรือใช้อีเมลและรหัสผ่านด้านล่าง",
    "openBrowser": "เปิดในเบราว์เซอร์",
    "openChrome": "เปิดใน Chrome",
    "manualHint": "แตะ ⋯ หรือไอคอนแชร์ แล้วเลือก “เปิดใน Safari” หรือ “เปิดในเบราว์เซอร์”",
    "copyLink": "คัดลอกลิงก์",
    "copied": "คัดลอกลิงก์แล้ว นำไปวางใน Chrome หรือ Safari",
    "copyFailed": "คัดลอกลิงก์ไม่ได้ กดค้างที่ช่องที่อยู่เพื่อคัดลอก"
  },
  "legal": {
    "terms": "ข้อกำหนดและเงื่อนไข",
    "privacy": "นโยบายความเป็นส่วนตัว",
    "cookie": "นโยบายคุกกี้",
    "version": "เวอร์ชัน {{version}}",
    "notFound": "ไม่พบเอกสารที่ขอ",
    "backHome": "กลับหน้าแรก",
    "close": "ปิด"
  },
  "profile": {
    "title": "ตั้งค่าโปรไฟล์",
    "joinSubtitle": "กรอกข้อมูลก่อนเข้าร่วมทีม",
    "startSubtitle": "กรอกข้อมูลเพื่อเริ่มใช้งาน",
    "shopName": "ชื่อร้านค้า",
    "shopNameRequired": "กรุณาระบุชื่อร้านค้า",
    "shopNamePlaceholder": "ระบุชื่อร้านค้า",
    "firstName": "ชื่อ",
    "firstNameRequired": "กรุณาระบุชื่อ",
    "firstNamePlaceholder": "ระบุชื่อ",
    "lastName": "นามสกุล",
    "lastNameRequired": "กรุณาระบุนามสกุล",
    "lastNamePlaceholder": "ระบุนามสกุล",
    "phone": "เบอร์โทรศัพท์",
    "phoneRequired": "กรุณาระบุเบอร์โทรศัพท์",
    "phoneInvalid": "กรุณาระบุเบอร์โทรศัพท์ที่ถูกต้อง",
    "phonePlaceholder": "ระบุเบอร์โทรศัพท์",
    "continue": "ดำเนินการต่อ",
    "start": "เริ่มใช้งาน",
    "createStoreFailed": "สร้างร้านค้าไม่สำเร็จ",
    "saveFailed": "บันทึกโปรไฟล์ไม่สำเร็จ"
  },
  "changePassword": {
    "title": "เปลี่ยนรหัสผ่าน",
    "saved": "เปลี่ยนรหัสผ่านสำเร็จ",
    "save": "บันทึก",
    "cancel": "ยกเลิก",
    "current": "รหัสผ่านปัจจุบัน",
    "currentRequired": "กรุณากรอกรหัสผ่านปัจจุบัน",
    "new": "รหัสผ่านใหม่",
    "newRequired": "กรุณากรอกรหัสผ่านใหม่",
    "tooShort": "รหัสผ่านต้องมีอย่างน้อย 6 ตัวอักษร",
    "confirm": "ยืนยันรหัสผ่านใหม่",
    "confirmRequired": "กรุณายืนยันรหัสผ่านใหม่",
    "mismatch": "รหัสผ่านไม่ตรงกัน"
  },
  "firebase": {
    "invalidEmail": "อีเมลไม่ถูกต้อง",
    "userDisabled": "บัญชีนี้ถูกระงับการใช้งาน",
    "userNotFound": "ไม่พบบัญชีนี้ กรุณาตรวจสอบอีเมลหรือสมัครใหม่",
    "wrongPassword": "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
    "invalidCredential": "อีเมลหรือรหัสผ่านไม่ถูกต้อง",
    "emailAlreadyInUse": "อีเมลนี้ถูกใช้งานแล้ว กรุณาเข้าสู่ระบบ",
    "weakPassword": "รหัสผ่านอ่อนเกินไป ต้องมีอย่างน้อย 6 ตัวอักษร",
    "tooManyRequests": "พยายามมากเกินไป กรุณาลองใหม่ในภายหลัง",
    "operationNotAllowed": "วิธีเข้าสู่ระบบนี้ยังไม่เปิดใช้งาน",
    "requiresRecentLogin": "กรุณาเข้าสู่ระบบใหม่อีกครั้งก่อนเปลี่ยนรหัสผ่าน",
    "networkRequestFailed": "เครือข่ายขัดข้อง กรุณาลองใหม่",
    "generic": "เกิดข้อผิดพลาด กรุณาลองใหม่อีกครั้ง"
  }
}
